export default __webpack_public_path__ + "static/media/IsolatedFileLineage.9b504fcd.png";